module.exports = __webpack_public_path__ + "img/sheep.20575203.jpg";